module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/icons/theme/shopping/pound-e627c4db802bc73471f82fad469a3594.svg";